import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom'; // [EXPERT_COMMENT]: Importación de componente - Se importa BrowserRouter para envolver la aplicación y proporcionar el contexto de enrutamiento.

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* [EXPERT_COMMENT]: Envoltura de la aplicación - Se envuelve el componente App con BrowserRouter para que todas las rutas funcionen correctamente. */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);


